export class TelecomProvider {

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/telecom-provider.ts